import script from "./PersonTags.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonTags.vue?vue&type=script&setup=true&lang=js"

import "./PersonTags.vue?vue&type=style&index=0&id=78a9849b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78a9849b"]])

export default __exports__